import React from 'react';
import { useSelector } from 'react-redux';

import { selectEmbeddedMode } from '../store/selectors/ui';

type EmbeddedModeProps = {
  children: React.ReactNode;
  display?: boolean;
  forBuildoutCrm?: boolean;
  forRethink?: boolean;
};

export const EMBEDDED_MODES = ['rethink', 'buildoutCrm'];

export default function EmbeddedMode(
  { children, display = false, forBuildoutCrm = false, forRethink = false }: EmbeddedModeProps
) {
  const embeddedMode = useSelector(selectEmbeddedMode);
  const inEmbedded = EMBEDDED_MODES.includes(embeddedMode);

  if ((embeddedMode == 'buildoutCrm' && !forBuildoutCrm) || (embeddedMode == 'rethink' && !forRethink)) {
    return null;
  }

  if (inEmbedded && display || (!inEmbedded && !display)) {
    return (
      <>
        {children}
      </>
    );
  }

  return null;
}
